export default __webpack_public_path__ + "static/media/dev.1cc4dca5.jpeg";